module.exports = __webpack_public_path__ + "img/IMG_6689_L_Black_MockedUp.e2e12094.jpg";